export const EXTERNAL_CANDIDATE_REPORT = 'externalCandidateReports';
export const GET_REPORT_TABLE_DATA = `${EXTERNAL_CANDIDATE_REPORT}/getReportAction`;
export const GET_REPORT_DROP_DOWN = `${EXTERNAL_CANDIDATE_REPORT}/getDropDownAction`;
export const GET_EXPORT_FILE = `${EXTERNAL_CANDIDATE_REPORT}/getExportFileAction`;
export const GET_REPORT = `${EXTERNAL_CANDIDATE_REPORT}/getIndividualReportAction`;